import { compose } from 'recompose'
import { connect } from 'react-redux'
import { aplicationName } from '../../../ConfigAplication'
const mapStateToProps = (state, props) => {

    const { AppReducer } = state;
    // console.log('AppReducer', AppReducer);
    let titulo = aplicationName;
    let actions = null;
    if (AppReducer.rAppBar && AppReducer.rAppBar.obj) {
        let values = AppReducer.rAppBar.obj;

        if (values.titulo) {
            titulo = values.titulo;
        }
        if (values.actions) {
            actions = values.actions;
        }
    }



    return { titulo, actions };
};


export default compose(
    connect(mapStateToProps, {})

);


// WEBPACK FOOTER //
// ./src/App/components/AppBar/AppBar.enhancer.js